// TODO: AUSL-362 add translations

export const GENDERS = [
  {
    name: 'Select a gender',
    value: '',
  },
  {
    name: 'Male',
    value: 'M',
  },
  {
    name: 'Female',
    value: 'F',
  },
]
